 
<script>
import Vue from "vue";
import VueI18n from "vue-i18n";
import {
    languages
} from "@/shared/languages";
import localStorageSvc from "@/services/localStorage";
Vue.use(VueI18n);
const messages = Object.assign(languages);
let lan = "fr";
if (localStorageSvc.getLan() != 2) lan = "en";
lan = 'en';
var i18n = new VueI18n({
    locale: lan,
    fallbackLocale: "en",
    messages
});


export default {
 setTitle(resourceKey){
        let vm = new Vue({ i18n });
        let title = vm.$t('pageTitle.appName');
        if(resourceKey){
           let temp = vm.$t('pageTitle.' + resourceKey);
           if(temp)
            title = title + ' - ' + temp;
        }
        document.title = title;
    },
    confirm(msg, title, yes, no) {
    let vm = new Vue({ i18n });
    let sTitle = title;
    if (!title) sTitle = vm.$t("labels.defaultConfirmTitle");
    vm.$confirm(sTitle, msg, yes, no).set("labels", { ok: vm.$t("labels.ok") });
  },     
}
</script>
 